/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateJobRequest
 */
export interface UpdateJobRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateJobRequest
     */
    cronExpression: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobRequest
     */
    description: string;
}

/**
 * Check if a given object implements the UpdateJobRequest interface.
 */
export function instanceOfUpdateJobRequest(value: object): value is UpdateJobRequest {
    if (!('cronExpression' in value) || value['cronExpression'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function UpdateJobRequestFromJSON(json: any): UpdateJobRequest {
    return UpdateJobRequestFromJSONTyped(json, false);
}

export function UpdateJobRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateJobRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'cronExpression': json['cronExpression'],
        'description': json['description'],
    };
}

export function UpdateJobRequestToJSON(json: any): UpdateJobRequest {
    return UpdateJobRequestToJSONTyped(json, false);
}

export function UpdateJobRequestToJSONTyped(value?: UpdateJobRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cronExpression': value['cronExpression'],
        'description': value['description'],
    };
}

